import { render, staticRenderFns } from "./ActiveClaims.vue?vue&type=template&id=3fe0da5b&scoped=true"
import script from "./ActiveClaims.vue?vue&type=script&lang=js"
export * from "./ActiveClaims.vue?vue&type=script&lang=js"
import style0 from "./ActiveClaims.vue?vue&type=style&index=0&id=3fe0da5b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe0da5b",
  null
  
)

export default component.exports